<template>
  <div class="header-top" ref="viewBox">
    <!-- 顶部导航 -->
    <div class="header-top-logo">
      <img src="@/assets/images/hpcopy/logo.png" />
    </div>
    <div class="header-top-nav">
      <div class="spanBox">
        <!-- :class="{'border-bottom': isUnderlined(index) }" -->
        <!-- :class="{ 类名1:布尔值，类名2:布尔值}" -->
        <!-- {{highlightedIndex}} -->
        <div
          class="span"
          :class="{ 'border-bottom spanA': isUnderlined(index) }"
          v-for="(item, index) in nav"
          :key="index"
          @click="handleClick(index, item.url)"
          @mouseenter="handleMouse(index)"
          @mouseleave="handleLeave()"
        >

          <div class="span-div">
            <img v-if="item.img!=''" class="span-img" src="@/assets/images/huo.png" alt="" />
            <span>{{ item.tit }}</span>
          </div>
        </div>
      </div>
      <!-- 工作台 -->
      <div v-if="isShowUser && isShowSupper==1" class="workBox" @click="gongzuotai">
        <div class="work">
          <img
            src="@/assets/images/hpcopy/gongzuotai.png"
            alt=""
          />
          <div style="display: inline-block">供应商</div>
        </div>
      </div>
      <!-- 通知 -->
      <div v-if="isShowUser" class="msg" @click="userNext('/Message')">
       <img v-if="userInfo.unread_num==0" src="@/assets/images/hpcopy/tongzhi.png" alt="" />
        <!--  <div class="dian" v-show="userInfo.unread_num>0"></div> -->
        <el-badge v-else :value="userInfo.unread_num" :max="99" class="item">
          <img src="@/assets/images/hpcopy/tongzhi.png" alt="" />
        </el-badge>
      </div>
      <div v-if="!isShowUser" class="workBox" @click="dialogVisible = true;chongxindiaoyong=true">
        <div class="work" >
          <!-- <img src="@/assets/images/Frame.png" alt="" /> -->
          <div style="display: inline-block">登录/注册</div>
        </div>
      </div>
      <!-- yonmghu -->
      <div
        class="headImg"
        @mouseenter="handleMouse1()"
        @mouseleave="handleLeave()"
        v-if="isShowUser"
      >

        <div class="headImgBigBox">
          <div  class="nicheng">
            <el-avatar  :src="userInfo.avatar" icon="el-icon-user-solid"></el-avatar>
            <span class="userName">{{ userInfo.nickname }}</span>
            <img src="@/assets/images/hpcopy/nicknameyou.png" alt="" />
          </div>
          <div
            class="user"
            v-show="isShowUserInfo"
            @mouseenter="handleMouseEnterUserInfo()"
            @mouseleave="handleLeaveUserInfo()"
          >
            <div class="user-header">
              <div class="user-header-left">
                <el-avatar  :src="userInfo.avatar" icon="el-icon-user-solid"></el-avatar>
              </div>
              <div class="user-header-right">
                <div>{{ userInfo.nickname }}</div>
                <div>{{ userInfo.mobile }}</div>
              </div>
            </div>
            <div v-if="userInfo.is_vip!=0" class="user-vip">
              <div class="user-vip-header">
                <div class="user-vip-left">
                  <div>{{ userInfo.is_vip == 1 ? '普通会员' :'订舱宝会员' }}</div>
                  <div>有效期至：{{userInfo.vip_expire_time}}</div>
                </div>
                <div class="user-vip-right" @click="userNext('/OpenMembership')">
                  <div>会员权益</div>
                </div>
              </div>
              <div
                class="user-vip-foot"
                @click="userNext('/Member')"
              >
                <div>会员中心</div>
                <!-- <img src="@/assets/images/下拉.png" alt="" /> -->
                <i class="el-icon-arrow-down"></i>
              </div>
            </div>
            <div v-if="userInfo.is_vip==0" class="user-vip">
              <div class="user-vip-header">
                <div class="user-vip-left">
                  <div>订好舱平台会员</div>
                  <div>开通会员，解锁更多平台功能</div>
                </div>
                <div class="user-vip-right" @click="userNext('/OpenMembership')">
                  <div>立即开通</div>
                </div>
              </div>
              <div
                class="user-vip-foot"
                @click="userNext('/OpenMembership')"
              >
                <div>会员权益</div>
                <!-- <img src="@/assets/images/下拉.png" alt="" /> -->
                <i class="el-icon-arrow-down"></i>
              </div>
            </div>
            <div class="user-nav">
              <div class="user-nav-box" @click="userNext('/Order')">
                <img src="@/assets/images/Frame1.png" alt="" />
                <div>我的订单</div>
              </div>
              <div class="user-nav-box" @click="userNext('/PriceInquiry')">
                <img src="@/assets/images/Frame2.png" alt="" />
                <div>查询记录</div>
              </div>
              <div class="user-nav-box user-nav-line" @click="userNext('/StareAt')">
                <img src="@/assets/images/Frame3.png" alt="" />
                <div>盯舱宝</div>
              </div>
              <!-- <div class="user-nav-box" @click="wyxd">
                <img src="@/assets/images/huo.png" alt="" />
                <div>我要下单</div>
              </div>
              <div class="user-nav-box" @click="cwgys">
                <img src="@/assets/images/huo.png" alt="" />
                <div>成为供应商</div>
              </div>
              <div class="user-nav-box user-nav-line" @click="wyfyj">
                <img src="@/assets/images/huo.png" alt="" />
                <div>我要发运价</div>
              </div> -->


              <div class="user-nav-box" @click="userNext('/UserInfo')">
                <img src="@/assets/images/Frame4.png" alt="" />
                <div>个人中心</div>
              </div>
              <div class="user-nav-box" @click="userNext('/Template')">
                <img src="@/assets/images/Frame1.png" alt="" />
                <div>模板中心</div>
              </div>
              <div class="user-nav-box" @click="userNext('/Invite')">
                <img src="@/assets/images/Frame5.png" alt="" />
                <div>邀请好友</div>
              </div>
              <div class="user-nav-box" @click="LogOut">
                <img src="@/assets/images/Frame6.png" alt="" />
                <div>退出登录</div>
              </div>
            </div>
          </div>
        </div>
      </div>

      <!-- <el-button class="shoucang" @click="choucangZM">收藏桌面</el-button> -->
      <!-- 登录弹窗 -->
      <!--  :before-close="handleClose" -->
      <el-dialog :visible.sync="dialogVisible" class="tanchuang" :show-close="false">
        <Login @message="receiveMessage" :chongxindiaoyong="chongxindiaoyong" />
      </el-dialog>

      <!-- 预览pdf -->
      
    </div>
  </div>
</template>

<script>
import Login from "../Login/LoginPage.vue";
import { supplierInfo,unReadNum } from "@/api/api";

export default {
  components: {
    Login,
  },
  props:{
    dialogVisibleLogin:{
      type:Boolean,
      required:true
    }
  },
  data() {
    return {
      // 通知图标
      MsgSrc: require("@/assets/images/通知.png"),
      // 导航
      nav: [
        {
          tit: "首页",
          url: "/",
          img:'',
        },
        {
          tit: "精选运价",
          url: "/SelectedFreightRates",
          img:'huo',
        },
        {
          tit: "现舱市场",
          url: "/Market",
          img:'',
        },
        {
          tit: "船东SPOT",
          url: "/ShipSPOT",
          img:'',
        },
        {
          tit: "美加到门",
          url: "/USToDoor",
          img:'huo',
        },
        {
          tit: "盯舱宝",
          url: "/StareAt",
          img:'',
        },
        {
          tit: "工具",
          url: "/Tool",
          img:'',
        },
      ],
      // 默认第一个有下划线
      highlightedIndex: 0,
      //   默认第一个有背景颜色
      highlightBackground: 0,
      //   是否显示隐藏
      isShow: null,
      //   导航栏展示
      showLists: ["精选运价", "现舱市场", "船东SPOT"],
      //   导航栏展示样式
      highlightIsShowList: null,
      // 控制是否显示 .headImg 的用户信息
      isShowHeadImg: false,
      // 控制是否显示 .user 的用户信息
      isShowUserInfo: false,
      scrollTopA: 0,
      // 登录弹窗是否出现
      dialogVisible: false,
      isShowUser: localStorage.getItem('isLogin'),
      userInfo: JSON.parse(localStorage.getItem("userInfo")),
      chongxindiaoyong:false,
      pdfUrl:'',

      isShowSupper:0,
    };
  },
  methods: {
    // 点击导航栏
    handleClick(index, url) {
      sessionStorage.setItem("lineIndex", index);
      if (!localStorage.getItem('isLogin')) {
        if (index != 0) {
          this.dialogVisible = true;
          this.chongxindiaoyong = true
        }
      } else {
        if (this.$route.path != url) {
          this.$router.push(url);
        } else {
          window.scrollTo(0, 0);
        }
        this.highlightedIndex = index;
      }
    },
    // 触发下划线
    isUnderlined(index) {
      return Number(this.highlightedIndex) === index;
    },
    // 点击送货标签
    handleClickTitle(index) {
      this.highlightBackground = index;
      this.marketIndex = index;
    },
    // 触发背景颜色
    isBackground(index) {
      return this.highlightBackground === index;
    },
    // 鼠标划入导航栏
    handleMouse(index) {
      this.isShow = index;
    },
    handleMouse1() {
      // 鼠标划入头像
      this.isShowUserInfo = true;
    },
    handleLeave() {
      this.isShow = null;
      // 鼠标划走头像
      // this.isShowHeadImg = true;
    },
    // 鼠标划入用户信息
    handleMouseEnterUserInfo() {
      this.isShowUserInfo = true;
    },
    // 鼠标划走用户信息
    handleLeaveUserInfo() {
      this.isShowUserInfo = false;
    },
    // 鼠标划入导航栏展示
    handleIsShowList(index) {
      this.highlightIsShowList = index;
    },
    // 触发导航栏展示样式
    isShowList(index) {
      return this.highlightIsShowList === index;
    },
    // 接收父子传值
    receiveMessage(data) {
      this.dialogVisible = false;
      this.isShowUser = true;
      this.userInfo = data.userInfo;
      this.isShowSupper = data.userInfo.is_supplier
      this.chongxindiaoyong = data.chongxindiao
      // 57735334
      // 57735334
    },
    // 退出登录
    LogOut() {
      localStorage.removeItem("userInfo");
      localStorage.removeItem("isLogin");
      localStorage.removeItem("token");
      sessionStorage.removeItem("has_password");
      sessionStorage.removeItem('menu')
    
      this.isShowUser = false;
      this.$message({
        offset:80,
        type:'success',
        message:'退出登录成功'
      })
      if (this.$route.path != "/index") {
        this.$router.push("/");
      }
    },
    async getSupplierInfo() {
      let supplier_id = JSON.parse(localStorage.getItem('userInfo')).supplier_id
        try {
          if (supplier_id==0 || supplier_id==null || supplier_id==undefined) { 
            this.$router.push('/ht/authentication')
            return 
          }
          const res = await supplierInfo({
              supplier_id:supplier_id
          }, {
            token: localStorage.getItem("token")
          });
          if(res.code==1){
              this.form = res.data;

              this.supplier_is_authentication=res.data.is_check
              this.supplier_reject_reason=res.data.reject_reason
              

              let userInfo = JSON.parse(localStorage.getItem('userInfo'))
              userInfo.supplier_is_authentication=res.data.is_check
              userInfo.supplier_reject_reason=res.data.reject_reason
              userInfo.supplier_enterprise_name=res.data.enterprise_name
              userInfo.supplier_email=res.data.email
              userInfo.supplier_is_vip=res.data.is_vip
              userInfo.supplier_expire_time=res.data.expire_time
              localStorage.setItem('userInfo',JSON.stringify(userInfo))

              if(res.data.is_check==2){
                  this.$router.push('/ht')
              }else{
                this.$router.push('/ht/authentication')
              }
          }
        } catch (error) {
            console.log(error,"获取失败");
        }
    },
    // 工作台
    gongzuotai(){
      this.getSupplierInfo()
      // let supplier_id = JSON.parse(localStorage.getItem('userInfo')).supplier_id
      // if(supplier_id==2){
      // }
    },
    // 个人资料跳转页面
    userNext(e){
      if(e=='/StareAt'){
        this.highlightedIndex=5
      }else if(e=='/Message'){
        this.highlightedIndex=-1
      }else{
        this.highlightedIndex=0
      }
      this.$router.push(e)
      sessionStorage.setItem("lineIndex", this.highlightedIndex);
    },
    // 调用接口  获取未读数量
    async getUnReadNum(){
        try {
            const res = await unReadNum({token:localStorage.getItem('token')})
            let storedObject = localStorage.getItem('userInfo');
            if (storedObject) { 
                let obj = JSON.parse(storedObject);
                obj.unread_num = res.data.unread_num;
                localStorage.setItem('userInfo', JSON.stringify(obj)); // 重新存储对象
                // location.reload()  // 修改本地存储  刷新页面
            }      
        } catch (error) {
            console.log(error,'失败');
        }
    },
    wyxd(){
      this.pdfUrl = 'https://serve.dhcang.com/resource/file/订好舱我要下单.pdf'
      window.open(this.pdfUrl, "_blank");
    },
    cwgys(){
      this.pdfUrl = 'https://serve.dhcang.com/resource/file/订好舱成为供应商.pdf'
      window.open(this.pdfUrl, "_blank");
    },
    wyfyj(){
      this.pdfUrl = 'https://serve.dhcang.com/resource/file/订好舱发布运价.pdf'
      window.open(this.pdfUrl, "_blank");
    },
    choucangZM(){
        const iconUrl ="https://serve.dhcang.com/resource/image/api/LOGO.ico"
        const urlContent = `[InternetShortcut]
        URL=https://www.dhcang.com
        IconIndex=0
        IconFile=${encodeURIComponent(iconUrl)}`;

        const blob = new Blob([urlContent], { type: 'application/x-msdownload' });
        const link = document.createElement('a');
        link.href = URL.createObjectURL(blob);
        link.download = '订好舱网站.url';
        link.click();
        URL.revokeObjectURL(link.href);
    },
  },
  beforeDestroy() {
  
  },
  mounted() {
    window.document.body.onscroll = () => {
      this.scrollTopA = document.documentElement.scrollTop;

      if (this.$refs.viewBox !== undefined && this.$refs.viewBox !== null) {
        if (
          document.documentElement.scrollTop >= 0 &&
          document.documentElement.scrollTop <= 500
        ) {
          // this.$refs.viewBox.style.background = "transparent";
          this.$refs.viewBox.style.boxShadow =
            "0px 0px 0px 0px rgba(0,0,0,0)";
        } else {
          // this.$refs.viewBox.style.background = "#FFFFFF";
          this.$refs.viewBox.style.boxShadow =
            "0px 10px 20px 0px rgba(0,0,0,0.05)";
        }
      }
    };

    this.getUnReadNum()

    if(localStorage.getItem("userInfo")){
      this.isShowSupper = JSON.parse(localStorage.getItem("userInfo")).is_supplier
    }
  },
  watch:{
    dialogVisibleLogin: {
        handler() {
            this.dialogVisible = this.dialogVisibleLogin;
        },
        deep: true
    },
    dialogVisible: {
        handler(newVal) {
            if(!newVal){
              this.$emit("message", {
                dialogVisibleLoginER:false,
              });
            }
        },
        deep: true
    }
  }
};
</script>

<style lang="scss" scoped>
div {
  display: inline-block;
}
// 导航点击样式
.border-bottom {
  border-bottom: 4px solid #064FAF;
  border-radius: 2px 2px 0px 0px;
  padding-bottom: 8px;
}

.header-top {
  // position: fixed;
  // top: 0;
  // left: 0;
  // right: 0;
  height: 100PX;
  display: flex;
  justify-content: space-between;
  padding: 0 80px;
  align-items: center;
  // background: pink;
  z-index: 9999;
  .header-top-logo {
    text-align: left;
    padding: 25px 0;
    img {
      width: 212PX;
      height: 63PX;
    }
  }

  .header-top-nav {
    // width: 758px;
    display: flex;
    align-items: center;
    .spanBox {
      padding: 37px 0 38px 0;
      margin-right: 24px;
      // display: inline-block;
      display: flex;
      align-items: start;
      
      .span {
        position: relative;
        display: inline-block;
        // height: 25px;
        margin-right: 48px;
        font-family: PingFang SC, PingFang SC;
        font-weight: 500;
        font-size: 16PX;
        color: #0F2D59;
        // line-height: 21px;
        text-align: center;
        font-style: normal;
        text-transform: none;
        // 鼠标样式
        cursor: pointer;
        
        .span-div{
          display: flex;
          align-items: center;
        }

        .span-img{
          width: 16px;
          margin-right: 4px;
        }
        &:last-child {
          margin-right: 0px;
        }

        .show {
          position: absolute;
          width: 100px;
          top: 27px;
          left: 50%;
          transform: translate(-50%);
          background: #fff;
          padding: 10px 0;
          border-radius: 8px 8px 8px 8px;
          div {
            padding: 10px 0;
            display: block;
            height: 20px;
            font-family: PingFang SC, PingFang SC;
            font-weight: 500;
            font-size: 14px;
            color: #999999;
            line-height: 16px;
            text-align: center;
            font-style: normal;
            text-transform: none;
          }
        }
      }
      .span:hover {
        // transition: transform 0.2s;
        transform: scale(1.2);
      }

      .spanA {
        color: #064FAF;
        font-weight: bold;
      }
    }
    .workBox {
      display: inline-block;
      // width: 100PX;
      vertical-align: middle;
      // 鼠标样式
      cursor: pointer;
      .work {
        // background: #b8b8b8;
        // background: rgb(255 255 255 / 0.3);
        background: rgba(6,79,175,0.16);
        border-radius: 33PX;
        padding: 8PX 14PX;
        color: #fff;
        display: flex;
        align-items: center;
        img {
          width: 20PX;
          height: 20PX;
        }
        div {
          vertical-align: middle;
          height: 22PX;
          font-family: PingFang SC, PingFang SC;
          font-weight: 500;
          font-size: 16PX;
            color: #064FAF;
          // line-height: 19px;
          text-align: left;
          font-style: normal;
          text-transform: none;
        }
      }
    }

    .phone {
      color: #fff;
    }

    .phoneB {
      color: #666666;
    }
    .msg {
      vertical-align: middle;
      margin-left: 24px;
      padding: 39px 0;
      position: relative;
      margin-right: 24px;
      img {
        width: 22PX;
        height: 22PX;
      }
      .dian {
        position: absolute;
        top: 34px;
        right: -7px;
        width: 8px;
        height: 8px;
        background: #ff3f3f;
        border-radius: 50%;
        border: 1px solid #ffffff;
      }
    }
    .headImg {
      vertical-align: middle;
      margin-right: 8px;
      .headImgBigBox {
        cursor: pointer;
        // width: 36px;
        height: 36px;
        border-radius: 50%;
        border: 1px solid #ffffff;
        // 设置相对定位
        position: relative;
        .el-avatar {
          width: 36PX;
          height: 36PX;
        }
        .nicheng{
          // line-height: 58px;
          // display: inline-block;
          display: flex;
          align-items: center;
          .userName{
            max-width: 130PX;
            overflow:hidden; 
            text-overflow:ellipsis; 
            white-space:nowrap;
          }
          span{
            font-weight: 500;
            font-size: 16PX;
            color: #0F2D59;
            margin-left: 8px;
          }

          img{
            width: 14PX;
            height: 14PX;
            margin-left: 2PX;
          }
        }
        .user {
          // 设置绝对定位
          position: absolute;
          top: 49px;
          right: 0;
          width: 272px;
          padding: 24px;
          background: linear-gradient(180deg, #f2f5ff 0%, #ffffff 100%);
          box-shadow: 0px 0px 10px 0px rgba(0, 0, 0, 0.1);
          border-radius: 10px 10px 10px 10px;
          z-index: 999;
          // display: none;
          .user-header {
            display: flex;
            .user-header-left {
              width: 48px;
              vertical-align: middle;
              margin-right: 10px;
            }
            .el-avatar {
              width: 48px;
              height: 48px;
              font-size: 36px;
              line-height: 52px;
            }
            .user-header-right {
              width: 200px;
              text-align: left;
              vertical-align: middle;
              div {
                &:nth-child(1) {
                  width: 200px;
                  height: 25px;
                  font-family: PingFang SC, PingFang SC;
                  font-weight: 500;
                  font-size: 18px;
                  color: #333333;
                  line-height: 21px;
                  text-align: left;
                  font-style: normal;
                  text-transform: none;
                }
                &:nth-child(2) {
                  width: 200px;
                  height: 20px;
                  font-family: PingFang SC, PingFang SC;
                  font-weight: 500;
                  font-size: 14px;
                  color: #999999;
                  line-height: 16px;
                  text-align: left;
                  font-style: normal;
                  text-transform: none;
                }
              }
            }
          }

          .user-vip {
            margin-top: 20px;
            width: 248px;
            height: 74px;
            background: linear-gradient(90deg, #dce6fd 0%, #dbe5fc 100%);
            border-radius: 8px 8px 8px 8px;
            // background: url("@/assets/images/背景1.png") no-repeat center
            //   center;
            background-image: url("../../assets/images/背景1.png");
            background-repeat: no-repeat;
            background-size: 100% 100%;
            padding: 12px 12px 7px;
            position: relative;

            .user-vip-header {
              display: flex;
              justify-content: space-between;
              align-items: center;

              .user-vip-left {
                height: 40px;
                text-align: left;

                div {
                  display: block;
                  &:nth-child(1) {
                    // width: 56px;
                    height: 20px;
                    font-family: PingFang SC, PingFang SC;
                    font-weight: 500;
                    font-size: 14px;
                    color: #000000;
                    line-height: 16px;
                    text-align: left;
                    font-style: normal;
                    text-transform: none;
                  }
                  &:nth-child(2) {
                    // width: 133px;
                    height: 17px;
                    font-family: PingFang SC, PingFang SC;
                    font-weight: 500;
                    font-size: 12px;
                    color: #999999;
                    line-height: 14px;
                    text-align: left;
                    font-style: normal;
                    text-transform: none;
                  }
                }
              }
              .user-vip-right {
                cursor: pointer;
                width: 60px;
                height: 24px;
                background: #ffffff;
                border-radius: 12px 12px 12px 12px;
                // opacity: 0.45;
                text-align: center;
                display: flex;
                align-items: center;
                justify-content: center;
                div {
                  // width: 40px;
                  // height: 14px;
                  font-family: PingFang SC, PingFang SC;
                  font-weight: 500;
                  font-size: 10px;
                  color: #0073f5;
                  line-height: 12px;
                  text-align: left;
                  font-style: normal;
                  text-transform: none;
                }
              }
            }

            .user-vip-foot {
              position: absolute;
              bottom: 4px;
              right: 12px;
              text-align: right;
              cursor: pointer;
              div {
                width: 48px;
                height: 17px;
                font-family: PingFang SC, PingFang SC;
                font-weight: 500;
                font-size: 12px;
                color: #000;
                line-height: 14px;
                text-align: left;
                font-style: normal;
                text-transform: none;
                vertical-align: middle;
              }
              img {
                vertical-align: middle;
              }
            }
          }

          .user-nav {
            margin-top: 20px;
            width: 100%;
            .user-nav-box {
              display: block;
              text-align: left;
              margin-bottom: 20px;
              cursor: pointer;
              img,
              div {
                vertical-align: middle;
              }
              div {
                // width: 56px;
                font-family: PingFang SC, PingFang SC;
                font-weight: 500;
                font-size: 14px;
                color: #666666;
                font-style: normal;
                text-transform: none;
                margin-left: 8px;
              }
              img{
                width: 16px;
              }
            }
            .user-nav-line {
              border-bottom: 1px solid #eeeeee;
              padding-bottom: 20px;
            }
          }
        }
      }
    }
    // .headImgBigBox:hover .user {
    //   display: block;
    // }
  }
}

// :deep(.el-dialog) {
//   width: 720px;
//   border-radius: 16px 16px 16px 16px;
//   .el-dialog__header,
//   .el-dialog__body {
//     padding: 0;
//   }
// }

.tanchuang{
    background: none;
  :deep(.el-dialog) {
    width: 1200px;
    // height: 456px;
    border-radius: 32px;
    .el-dialog__header,
    .el-dialog__body {
      padding: 0;
    }
  }
}

/* 针对600px到1300px宽度的设备 */
// @media screen and (min-width: 600px) and (max-width: 1300px) {
//     .spanBox {
//         .span{
//           font-size: 18PX;
//         }
//     }
// }


 
// /* 在中等屏幕上的样式 */
// @media screen and (min-width: 768px) and (max-width: 1024px) {
//   /* 样式规则 */
// }
 
.shoucang{
  background: rgba(6,79,175,0.16);
  padding: 10PX 14PX;
  color: #fff;
  display: flex;
  color: #064FAF;
  margin-left: 12PX;
}
</style>